import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import { CHANNEL_CONNECTION_WHATSAPP_CONFIGURATION_ADDS_SAVED, CHANNEL_CONNECTION_WHATSAPP_CONFIGURATION_CHANGES_SAVED, CHANNEL_DISCONNECT_WHATSAPP_CLICKED, CHANNEL_DISCONNECT_WHATSAPP_CONFIRMED, CHANNEL_CONNECTION_BLIPCHAT_CONFIGURATION_ADDS_SAVED, CHANNEL_CONNECTION_BLIPCHAT_CONFIGURATION_CHANGES_SAVED, CHANNEL_CONNECTION_BLIPCHAT_CONFIGURATION_RECORD_AUDIO_CHANGES, CHANNEL_CONNECTION_MESSENGER_CONFIGURATION_FACEBOOK_LOGIN_CLICKED, CHANNEL_CONFIGURATION_TOKEN_EXPIRED, CHANNEL_CARD_CLICKED, CHANNEL_CONNECTION_BLIPCHAT_CONFIGURATION_OPEN_IMAGE_IN_FRAME_CHANGES, } from './ChannelsSegmentEvents';
export class ChannelsSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        this.SegmentService = SegmentService;
    }
    setApplication(application) {
        this.application = application;
    }
    trackChannelConfigurationTokenExpired(payload, success) {
        this.trackApplicationEvent(CHANNEL_CONFIGURATION_TOKEN_EXPIRED, payload, success);
    }
    trackChannelCardClicked(payload, success) {
        this.trackApplicationEvent(CHANNEL_CARD_CLICKED, payload, success);
    }
    trackConnectionWhatsappConfigurationAddsSaved(payload, success) {
        this.trackEvent(CHANNEL_CONNECTION_WHATSAPP_CONFIGURATION_ADDS_SAVED, payload, success);
    }
    trackConnectionWhatsappConfigurationChangesSaved(payload, success) {
        this.trackEvent(CHANNEL_CONNECTION_WHATSAPP_CONFIGURATION_CHANGES_SAVED, payload, success);
    }
    trackConnectionBlipchatConfigurationAddsSaved(payload, success) {
        this.trackApplicationEvent(CHANNEL_CONNECTION_BLIPCHAT_CONFIGURATION_ADDS_SAVED, payload, success);
    }
    trackConnectionBlipchatConfigurationChangesSaved(payload, success) {
        this.trackApplicationEvent(CHANNEL_CONNECTION_BLIPCHAT_CONFIGURATION_CHANGES_SAVED, payload, success);
    }
    trackConnectionBlipchatConfigurationRecordAudioChanges(payload, success) {
        this.trackApplicationEvent(CHANNEL_CONNECTION_BLIPCHAT_CONFIGURATION_RECORD_AUDIO_CHANGES, payload, success);
    }
    trackConnectionBlipchatConfigurationOpenImageInFrameChanges(payload, success) {
        this.trackApplicationEvent(CHANNEL_CONNECTION_BLIPCHAT_CONFIGURATION_OPEN_IMAGE_IN_FRAME_CHANGES, payload, success);
    }
    trackConnectionMessengerConfigurationFacebookLoginClicked(payload, success) {
        this.trackEvent(CHANNEL_CONNECTION_MESSENGER_CONFIGURATION_FACEBOOK_LOGIN_CLICKED, payload, success);
    }
    disconnectWhatsAppTrack(payload, success) {
        this.trackApplicationEvent(CHANNEL_DISCONNECT_WHATSAPP_CLICKED, payload, success);
    }
    disconnectWhatsAppConfirmedTrack(payload, success) {
        this.trackApplicationEvent(CHANNEL_DISCONNECT_WHATSAPP_CONFIRMED, payload, success);
    }
    async trackApplicationEvent(event, payload, success) {
        const application = this.application;
        await this.SegmentService.createApplicationTrack({
            trackEvent: event,
            application,
            payload: { ...payload, Status: this.eventStatus(success) },
        });
    }
    trackEvent(event, payload, success) {
        this.SegmentService.createBotTrack(event, this.application, { ...payload, Status: this.eventStatus(success) });
    }
    eventStatus(success) {
        if (success === undefined) {
            return;
        }
        return success ? SUCCESS_STATUS : FAILURE_STATUS;
    }
}
ChannelsSegmentService.$inject = ['SegmentService'];
